import styled from 'styled-components'

export const Container = styled.div`
  margin-left: 1em;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const Type = styled.div`
  position: relative;
  width: 50%;
`

export const Value = styled.div`
  position: relative;
  width: 30%;
`